import { render } from "./PageWhiteSection.vue?vue&type=template&id=76665d8c"
import script from "./PageWhiteSection.vue?vue&type=script&lang=js"
export * from "./PageWhiteSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__